import { useState, useMemo } from 'react'
import {
    useSortable,
  } from '@dnd-kit/sortable';
  import { useSelector } from "react-redux";
import styles from './index.module.scss'
import { MenuOutlined, MoreOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { Tooltip, Typography, message, InputNumber } from 'antd'
import {CSS} from '@dnd-kit/utilities';
import { 
    ModalityList,
    MultipleListsPopover,
    AddFootnoteModal,
 } from 'src/DigitalProtocolModule/components'
import talkIcon from "src/assets/svgs/icon-talk.svg";
import talkIconError from "src/assets/svgs/icon-talk-error.svg";
import { fetchHistory } from 'src/actions/historyTrial';
import { ActivityFootnoteTooltip } from '../ActivityFootnoteTooltip';
import { useFootnoteHooks } from 'src/DigitalProtocolModule/hooks';
import { FOOTNOTE_GROUP } from 'src/DigitalProtocolModule/constants';
import { FrequencyInputNumber } from './FrequencyInputNumber';
import './index.scss';

const { Text } = Typography;


const activity_items:Digital_Protocol_SoA_Table_Data.PopoverItemsList[] = [  
    { name: 'Add Footnote', icon: '', color: 'black'  },  
    { name: 'Copy Visit Mapping', icon: '', color: 'black'  },  
    { name: 'Delete', icon: '', color: 'red'  },  
]; 

const cell_items:Digital_Protocol_SoA_Table_Data.PopoverItemsList[] = [
    { name: 'Add Footnote', icon: '', color: 'black'  },
];

interface DraggableItemProps {
    activity_item: Digital_Protocol_SoA_Table_Data.Entity
    idx: number
    type: string
    key:number
    modalityOptions: Digital_Protocol_SoA_Table_Data.ModalityOption[]
    visits:  Array<number>
    clickHandler: (e:any, activity_item:Digital_Protocol_SoA_Table_Data.Entity, idx:number) => void,
    moveActivityHandler: (id: number, category: string) => void,
    onModalityChange: (e, evt:Digital_Protocol_SoA_Table_Data.Entity, id: number) => void,
    whetherDraggable: Digital_Protocol_SoA_Table_Data.WhetherDraggable
    unitIndex: string
    onVisitMapping: (activity:Digital_Protocol_SoA_Table_Data.Entity) => void
    trial_id: string
    table_id: number
    dprot_id: number
    week: number
    day: number
    onDeleteActivity:(activity:Digital_Protocol_SoA_Table_Data.Entity) => void
    onFrequencyChange: (e, evt:Digital_Protocol_SoA_Table_Data.Entity, id: number) => void,
    isReadOnly?: boolean;
}

export function DraggableItem({
    activity_item,
    idx,
    type,
    modalityOptions,
    visits,
    key,
    clickHandler,
    moveActivityHandler,
    onModalityChange,
    onVisitMapping,
    whetherDraggable,
    unitIndex,
    trial_id,
    table_id,
    dprot_id,
    week,
    day,
    onDeleteActivity,
    onFrequencyChange,
    isReadOnly = false,
  }: DraggableItemProps) {
    // get footnote config
    const footnoteConfigState = useSelector(fetchHistory).data.dpFootnoteConfig;

    const { getFootnoteStateMergedWithSoftSave, doFootnoteSoftDelete } = useFootnoteHooks()

    const [footnoteMergedDataState] = useState(getFootnoteStateMergedWithSoftSave())
    const [isOpenAddFootnoteModal, setIsOpenAddFootnoteModal] = useState<Digital_Protocol_SoA_Table_Data.OpenFootnoteType>({
        visible: false
    })

    const activityFootnoteList: DPFootnote.FootnoteData[] = useMemo(() => {
        return footnoteMergedDataState?.filter(
            (item: DPFootnote.FootnoteData) =>
                item?.footnote_group === FOOTNOTE_GROUP.ACTIVITY &&
                item?.activity_id === activity_item.activity_id
            ).map((item: DPFootnote.FootnoteData) => {
                const footnoteType = footnoteConfigState.footnoteTypeList.find(typeItem => typeItem.footnote_type_id === item.footnote_type_id)
                return {
                    ...item,
                    footnote_type: footnoteType?.footnote_type
                }
            });
    }, [footnoteConfigState, footnoteMergedDataState]);
    const existWarningInActivityFootnote = useMemo(
        () => activityFootnoteList.some((item) => Boolean(item.warn)),
        [activityFootnoteList]
    );

    const cellFootnotesListForLine: DPFootnote.FootnoteData[] = useMemo(() => {
        return footnoteMergedDataState?.filter(
            (item: DPFootnote.FootnoteData) =>
                item?.footnote_group === FOOTNOTE_GROUP.CELL &&
                item?.activity_id === activity_item.activity_id
            ).map((item: DPFootnote.FootnoteData) => {
                const footnoteType = footnoteConfigState.footnoteTypeList.find(typeItem => typeItem.footnote_type_id === item.footnote_type_id)
                return {
                    ...item,
                    footnote_type: footnoteType?.footnote_type
                }
            });
    }, [footnoteConfigState, footnoteMergedDataState]);

    const moveActivty = (idx, category) => {
        moveActivityHandler(idx, category)
    }

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
      } = useSortable({id: activity_item.activity_id, disabled: whetherDraggable[activity_item.Categories] !== activity_item.activity_id});

    const modailtyChangeHandler = (e,evt,idx) => {
        onModalityChange(e,evt,idx)
    }

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        cursor: `${whetherDraggable[activity_item.Categories] !== activity_item.activity_id? 'default' : 'move'}`,
        touchAction: 'none',
    };

    const actionHandler = (name, idx, activity) => {
        if(name === "Copy Visit Mapping") {
            onVisitMapping(activity)
        } else if (name === "Add Footnote") {
            setIsOpenAddFootnoteModal({
                visible: true,
                footnote_group: FOOTNOTE_GROUP.ACTIVITY,
                trial_uuid: trial_id,
                table_id,
                dprot_id,
                activity,
            })
        } else if (name === "Delete") {                   
            handleDeleteFootnote(
                [...activityFootnoteList, ...cellFootnotesListForLine]
                    .filter(item => item.activity_id === activity.activity_id)
                    .map(item => item.footnote_id)
            );
            onDeleteActivity(activity)
        }
    }

    const handleEditInFootnoteTooltipForActivity = (footnote_type_id, otherParams) => {
        setIsOpenAddFootnoteModal({
            visible: true,
            footnote_group: FOOTNOTE_GROUP.ACTIVITY,
            trial_uuid: trial_id,
            table_id,
            dprot_id,
            activity: otherParams?.activityItem,
            footnote_type_id
        })
    }

    const handleEditInFootnoteTooltipForCell = (footnote_type_id, otherParams) => {
        setIsOpenAddFootnoteModal({
            visible: true,
            footnote_group: FOOTNOTE_GROUP.CELL,
            trial_uuid: trial_id,
            table_id,
            dprot_id,
            activity: otherParams?.activityItem,
            period_id: otherParams?.condition?.period_id,
            visit_number: otherParams?.condition?.visits,
            week,
            day,
            footnote_type_id
        })
    }

    const handleDeleteFootnote = (footnote_id: any[]) => {
        // soft delete footnote
        doFootnoteSoftDelete(footnote_id)
    }
 
 
    const frequencyChangeHandler = (e, idx, activityItem) => {  
        const regex = /^[^a-zA-Z]*$/;  
        const value = e.target.value || "1";    // default to 1 when no input
        const parsedValue = parseInt(value);  
      
        if (!regex.test(value) || isNaN(parsedValue) || parsedValue < 1 || parsedValue > 15) {  
            message.error("Invalid input. Please enter a value between 1 and 15.");  
            const fallbackValue = isNaN(parsedValue) || parsedValue < 1 ? 1 : 15;  
            onFrequencyChange(value, idx, activityItem);
            return;  
        }  
      
        onFrequencyChange(value, idx, activityItem);  
    };  

    const cellActionHandler = (name: string, idx: number, activity: Digital_Protocol_SoA_Table_Data.Entity, condition: Digital_Protocol_SoA_Table_Data.Condition) => {
        if (name === "Add Footnote") {
            setIsOpenAddFootnoteModal({
                visible: true,
                footnote_group: FOOTNOTE_GROUP.CELL,
                trial_uuid: trial_id,
                table_id,
                dprot_id,
                activity,
                period_id: condition?.period_id,
                visit_number: condition?.visits,
                week,
                day,
            })
        } else if (name === "Reset") {
        }
    } 
  
    return (
        <>
            <div className="td draggableItem" style={style} ref={setNodeRef} key={activity_item?.activity_id} {...attributes} {...listeners}>
                <div className={styles.eventItem}  key={`${type.toLowerCase()}_${idx}`}> 
                    <div className={`${styles.eventsWrapper}`}>
                        <div className={`${styles.eventsActivtyContainer}`}> 
                            <MenuOutlined className={styles.dragIcon} style={{fontSize: '11px',marginTop: '3px', marginLeft: '5px', marginRight: '10px', color: `${whetherDraggable[activity_item.Categories] !== activity_item.activity_id? 'transparent' : 'black'}`,}}/> 
                            <span className={styles.activityHolder}>
                                <div className={styles.activityName}>
                                    <Tooltip title={activity_item["Standard Activity"]}>
                                        <Text onClick={() => moveActivty(activity_item?.activity_id, activity_item?.Categories)} ellipsis> {activity_item["Standard Activity"]} </Text>
                                    </Tooltip>
                                    {activityFootnoteList?.length > 0 && (
                                        <Tooltip title={
                                            <ActivityFootnoteTooltip
                                                footnoteList={activityFootnoteList}
                                                activityItem={activity_item}
                                                isReadOnly={isReadOnly}
                                                onEdit={handleEditInFootnoteTooltipForActivity}
                                                onDel={handleDeleteFootnote}/>
                                            }
                                            overlayInnerStyle={{whiteSpace: "pre-wrap", borderRadius: 8, backdropFilter: "blur(3px)"}}
                                            overlayClassName="footnote-tooltip"
                                            placement="topLeft"
                                            arrowPointAtCenter={true}
                                            zIndex={999}
                                            >
                                            <img src={existWarningInActivityFootnote ? talkIconError : talkIcon} className={styles.talkIcon} alt="" />
                                        </Tooltip>
                                    )}
                                </div>
                                {!isReadOnly && (
                                    <MultipleListsPopover items={activity_items} onAction={actionHandler} idx={idx} activityItem={activity_item}>  
                                        <MoreOutlined className={styles.activityActions} /> 
                                    </MultipleListsPopover>
                                )}
                            </span>
                        </div>                     

                        <div className={`${styles.statusRow} ${styles.eRow} ${styles.visitsRow}`}>
                            <div className={`${styles.column} ${styles.td}`}></div>
                        </div> 
                    </div>

                    <div className={`${styles.statusRow} ${styles.eRow}`}>
                            {activity_item?.condition?.map((con, idx) => 
                                {
                                    const targetItem = modalityOptions?.find(m => m.key.toString() == con.modality)
                                    const cellFootnotesList = cellFootnotesListForLine?.filter(item => item.period_id === con.period_id && item.visit === con.visits) || []
                                    return (
                                        <MultipleListsPopover items={cell_items} onAction={cellActionHandler} condition={con} activityItem={activity_item} idx={idx} trigger={unitIndex !== 'Frequency view' ? "contextMenu" : ""} key={idx} disabled={isReadOnly}>
                                            <div className={`${styles.dctTd} ${unitIndex === 'Frequency view' && !con.modality && !con.modality_name ? styles.isFrequency : ''}`} key={`${type.toLowerCase()}_event_${idx}`} >
                                                <span className="incon-wrapper" style={{ display: 'inline-block', cursor: 'pointer'}}>
                                                    { unitIndex === 'Frequency view' ? 
                                                        (
                                                        <FrequencyInputNumber
                                                            con={con}
                                                            activityItem={activity_item}
                                                            index={idx}
                                                            onBlur={frequencyChangeHandler}
                                                            isReadOnly={isReadOnly}
                                                        />
                                                 ) : (
                                                        <>
                                                            <Tooltip
                                                                title={
                                                                <ModalityList 
                                                                    evt={activity_item} 
                                                                    idx={idx} 
                                                                    value={con.modality} 
                                                                    onModalityChange={modailtyChangeHandler} 
                                                                    modalityOptions={modalityOptions}
                                                                />}
                                                                color="#ffffff"
                                                                mouseEnterDelay={0.2}
                                                                visible={isReadOnly ? false : undefined}
                                                                >
                                                                {Boolean(con.modality) ? 
                                                                (<img 
                                                                    alt=''
                                                                    src={targetItem?.icon} 
                                                                    onClick={(e) => !isReadOnly && clickHandler(e, activity_item, idx)} 
                                                                    style={{ backgroundColor: targetItem?.color, borderRadius: '50%' }} 
                                                                    />)
                                                                : !isReadOnly ? (
                                                                    <PlusCircleOutlined onClick={(e) => clickHandler(e, activity_item, idx)}/>
                                                                ) : ""}
                                                            </Tooltip>

                                                            {cellFootnotesList.length > 0 && (
                                                                <Tooltip title={
                                                                    <ActivityFootnoteTooltip
                                                                        footnoteList={cellFootnotesList}
                                                                        activityItem={activity_item}
                                                                        condition={con}
                                                                        isReadOnly={isReadOnly}
                                                                        onEdit={handleEditInFootnoteTooltipForCell}
                                                                        onDel={handleDeleteFootnote}/>
                                                                    }
                                                                    overlayInnerStyle={{whiteSpace: "pre-wrap", borderRadius: 8, backdropFilter: "blur(3px)"}}
                                                                    overlayClassName="footnote-tooltip"
                                                                    placement="topLeft"
                                                                    arrowPointAtCenter={true}
                                                                    zIndex={999}
                                                                    >
                                                                    <img src={cellFootnotesList.some(item => Boolean(item.warn)) ? talkIconError : talkIcon} className={styles.talkIcon} alt="" />
                                                                </Tooltip>
                                                            )}
                                                        </>
                                                    )}
                                                </span>
                                            </div>
                                        </MultipleListsPopover>
                                    )
                                }
                            )} 
                    </div>   
                </div>
            </div>
            {isOpenAddFootnoteModal.visible && (
                <AddFootnoteModal
                    isOpen={isOpenAddFootnoteModal}
                    onCancel={() => setIsOpenAddFootnoteModal({visible: false})}
                />
            )}
        </>
    )
}